import i18n from '@/config/i18n'
import store from '@/store'
import { getAppTitle } from '@/scripts/root/appTitle'
import {
  getDocumentLanguage,
  normalizeLanguage,
  resolveInitialLanguage,
  SupportedLanguage,
} from '@/scripts/root/language'

const syncI18nLanguage = (lang: SupportedLanguage) => {
  i18n.global.locale.value = lang
}

const setLang = (lang: string): void => {
  const selectedLang = normalizeLanguage(lang) || resolveInitialLanguage()

  syncI18nLanguage(selectedLang)
  store.commit('setAppLanguage', selectedLang)
  document.documentElement.setAttribute(
    'lang',
    getDocumentLanguage(selectedLang)
  )
  document.documentElement.setAttribute(
    'dir',
    selectedLang === 'ar' ? 'rtl' : 'ltr'
  )

  const separator = ' | '
  const separatorIndex = document.title.lastIndexOf(separator)
  const pageTitle =
    separatorIndex >= 0 ? document.title.slice(0, separatorIndex) : ''
  document.title = pageTitle
    ? `${pageTitle}${separator}${getAppTitle()}`
    : getAppTitle()
}

export default setLang
